import React, { useEffect, useMemo, useRef, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import axios from "axios";



const PDCOpenPopup = ({ data, setOpenPDC }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [currencies, setCurrencies] = useState([]);

  const [selectedVoucherType, setSelectedVoucherType] = useState("JV");
  const [selectedVoucherDescription, setSelectedVoucherDescription] =
    useState("Voucher");

  const [pvnoFromAPI, setPVnoFromAPI] = useState("");
  const [maxVoucherNo, setMaxVoucherNo] = useState("");
  const [disableModify, setDisableModify] = useState(true);
  // const [disableGenerate, setDisableGenerate] = useState(true);
  const [disableGenerate, setDisableGenerate] = useState(false);
  const [voucherTypeList, setVoucherTypeList] = useState([]);
  const [voucherTimeLineList, setVoucherTimeLineList] = useState([]);
  const [jvDate, setJvDate] = useState(new Date().toISOString().split("T")[0]);
  const [jvRecurringDate, setJvRecurringDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [accounts, setAccounts] = useState([]);
  const [voucherModalOpen, setVoucherModalOpen] = useState(false);
  const [searchVoucherAccountTerm, setSearchVoucherAccountTerm] = useState("");
  const [frequency, setFrequency] = useState("");
  const [value, setValue] = useState("ALL");
  const [inputVoucherValue, setInputVoucherValue] = useState("");
  const [inputVoucherValueAccount, setInputVoucherValueAccount] = useState("");
  const [inputVoucherValueDescription, setInputVoucherValueDescription] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [filteredPDCAccounts, setFilteredPDCAccounts] = useState([]);
  const [ty, setTY] = useState([]);
  const [selectedVoucherAccount, setSelectedVoucherAccount] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyRate, setSelectedCurrencyRate] = useState("");

  const [finalAmount, setFinalAmount] = useState(null);

  const [pdcDropdownOpenIndex, setPdcDropdownOpenIndex] = useState(null);
  const [pdcHighlightedIndex, setPdcHighlightedIndex] = useState(-1);
  const [pdcSearchTerm, setPdcSearchTerm] = useState("");
  const [pdcModalOpen, setPdcModalOpen] = useState(false);
  const [recurringJournal, setRecurringJournal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSavePopup, setOpenSavePopup] = useState(false);
  const [openModifyPopup, setOpenModifiedPopup] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [openErrorModifySnackbar, setOpenErrorModifySnackbar] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const [isCheckedRepeatAmount, setIsCheckedRepeatAmount] = useState(false);
  const [isCheckedRepeatDesc, setIsCheckedRepeatDesc] = useState(false);
  const [isVatOn, setIsVatOn] = useState(false);
  const [modifyPopup, setModifyPopup] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [modifyVoucherPage, setModifyVoucherPage] = useState(false);
  const [sumOfDebit, setSumOfDebit] = useState(0);
  const [sumOfCredit, setSumOfCredit] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("daily");
  const [modifyVoucherNo, setModifyVoucherNo] = useState("");

  const [savedVNO, setSavedVNO] = useState("");
  const [modifiedVNO, setModifiedVNO] = useState("");
  const [generatedEntriesState, setGeneratedEntriesState] = useState([]);
  const [setupBillAccount, setSetupBillAccount] = useState("");
  const [selectedAccountsState, setSelectedAccountsState] = useState([]);
  const [entries, setEntries] = useState([]);
  const accountRowContainerRef = useRef(null);
  const accountContainerRef = useRef(null);
  const setupBillContainerRef = useRef(null);
  const accountRefs = useRef([]);
  const voucherDropdownRefs = useRef([]);
  const accountNameRefs = useRef([]);
  const invRefs = useRef([]);
  const deptRefs = useRef([]);
  const descriptionRefs = useRef([]);
  const tyRefs = useRef([]);
  const amountRefs = useRef([]);
  const curRefs = useRef([]);
  const rateRefs = useRef([]);
  const fcBalRefs = useRef([]);
  const chqNoRefs = useRef([]);
  const chqDateRefs = useRef([]);
  const reccurringDateRefs = useRef([]);
  const bankRefs = useRef([]);
  const pdcAccRefs = useRef([]);
  const xRefs = useRef([]);
  const jobCodeRefs = useRef([]);
  const cCenterRefs = useRef([]);
  const costCodeRefs = useRef([]);
  const vatAmtRefs = useRef([]);
  const trnRefs = useRef([]);
  const totalRefs = useRef([]);
  const isVatRefs = useRef([]);
  const pdcDropdownRefs = useRef([]);
  const voucherTypeRefs = useRef(null);
  const [deptCodeList, setDeptCodeList] = useState([]);
  const [deptCode, setDeptCode] = useState("");
  const [obList, setOBList] = useState([]);

  useEffect(() => {
    fetchOBList();
    fetchCurrencyList();
    fetchDeptCodeList();
  }, []);

  const handleChange = (index, field, value) => {
    const cleanValue = value?.trim?.() ?? "";
    setEntries((prevEntries) => {
      const updatedEntries = [...prevEntries];
      updatedEntries[index] = {
        ...updatedEntries[index],
        [field]: cleanValue,
      };
      return updatedEntries;
    });
  };

  // const handleChangeAmountEntry = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       AMOUNT: amount,
  //       FCBalAmt: Number(amount / rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeFCBalAmt = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const fcBalAmt = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       FCBalAmt: fcBalAmt,
  //       AMOUNT: Number(fcBalAmt * rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeRate = (index, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const rate = parseFloat(value) || 1;
  //     const fcBalAmt = parseFloat(updated[index].FCBalAmt) || 0;

  //     updated[index] = {
  //       ...updated[index],
  //       rate,
  //       AMOUNT: Number(fcBalAmt * rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

  // const handleChangeAmountModify = (index, field, value) => {
  //   setEntries((prevEntries) => {
  //     const updated = [...prevEntries];
  //     const amount = parseFloat(value) || 0;
  //     const rate = parseFloat(updated[index].rate) || 1;

  //     updated[index] = {
  //       ...updated[index],
  //       amount: amount,
  //       FCBalAmt: Number(amount / rate).toFixed(2),
  //     };
  //     return updated;
  //   });
  // };

const recalculateRow = (row) => {
    const amount = parseFloat(row.amount) || 0;
    const rate = parseFloat(row.rate) || 1;
    const fcBalAmt = parseFloat(row.FCBalAmt) || 0;

    // If amount changed → recompute FC
    if (row.amount !== undefined) {
      return { ...row, FCBalAmt: Number(amount / rate).toFixed(2) };
    }
    // If FC changed → recompute amount
    if (row.FCBalAmt !== undefined) {
      return { ...row, amount: Number(fcBalAmt * rate).toFixed(2) };
    }
    // If rate changed → recompute amount from FC (or from amount if FC=0)
    const base = fcBalAmt || amount;
    return {
      ...row,
      amount: Number(base * rate).toFixed(2),
      FCBalAmt: Number(base / rate).toFixed(2),
    };
  };

  const handleAmountChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], amount: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  const handleFCChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], FCBalAmt: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  const handleRateChange = (index, value) => {
    setEntries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], rate: value };
      return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
    });
  };

  // const handleCurrencyChange = (index, curno) => {
  //   const cur = currencies.find((c) => c.curno === curno);
  //   const rate = cur?.rate ? parseFloat(cur.rate) : 1;

  //   setEntries((prev) => {
  //     const updated = [...prev];
  //     updated[index] = { ...updated[index], curno, rate };
  //     return updated.map((r, i) => (i === index ? recalculateRow(r) : r));
  //   });
  // };

  const handleTyData = (index) => {
    setTY((prev) =>
      prev.map((value, i) =>
        i === index ? (value === "D" ? "C" : "D") : value
      )
    );
    setEntries((prevEntries) => {
      const newEntries = [...prevEntries];
      newEntries[index] = {
        ...newEntries[index],
        ty: newEntries[index].ty === "C" ? "D" : "C",
      };
      return newEntries;
    });

    setTimeout(() => {
      // wait until new row is rendered
      // const lastIndex = amountRefs.current.length - 1;
      const lastIndex = amountRefs.current.length;
      amountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
    // amountRefs.current[index + 1]?.focus();
  };

  //   const handleDropdownSelectAccount = (rowIndex, acc) => {
  //     setSelectedVoucherAccount(acc);
  //     handleChange(rowIndex, "account", acc.ACCOUNT);
  //     handleChange(rowIndex, "description", acc.DESCRIPTION);
  //     setDropdownOpenIndex(null);
  //     setHighlightedIndex(-1);
  //     invRefs.current[rowIndex]?.focus(); // focus reference input

  //     setSelectedAccountsState((prev) => {
  //       const updated = [...prev];
  //       updated[rowIndex] = true;
  //       return updated;
  //     });
  //   };

  const handleAddRow = () => {
    const lastRow = entries.length > 0 ? entries[entries.length - 1] : null;
    setEntries([
      ...entries,
      {
        jvdate: "",
        dept: "",
        INV: "",
        DESCR: "",
        ty: lastRow?.ty === "D" ? "C" : "D",
        amount: 0,
        CUR: "AED",
        rate: 1,
        FCBalAmt: 0,
        JOBCODE: "",
        costCode: "",
      },
    ]);
    setTY((prev) => [...prev, lastRow?.ty === "D" ? "C" : "D"]);

    setTimeout(() => {
      // wait until new row is rendered
      const lastIndex = accountRefs.current.length - 1;
      accountRefs.current[lastIndex]?.focus(); // focus new row's first input
    }, 0);
  };

  const handleCurrencyChange = (index, value) => {
    const selected = currencies.find((cur) => cur.curno === value);
    const rate = parseFloat(selected?.rate) || 1;

    setEntries((prev) => {
      const updated = [...prev];
      const current = updated[index];

      const amount = parseFloat(current.AMOUNT) || 0;
      const fcBalAmt = parseFloat(current.FCBalAmt) || 0;

      updated[index] = {
        ...current,
        curno: selected.curno,
        rate,
        AMOUNT: amount
          ? Number(amount).toFixed(2)
          : Number(fcBalAmt * rate).toFixed(2),
        FCBalAmt: fcBalAmt
          ? Number(fcBalAmt).toFixed(2)
          : Number(amount / rate).toFixed(2),
      };
      return updated;
    });
  };

  const fetchOBList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    // const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${company_code_from_local_storage}/ACCOPENING/-/-/${data.accountNo}/${currentSelectedDepartment}/-/-`;
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMDocTransfer/${COMPANY_CODE}/ACCOPENING/-/-/${data.accountNo}/${currentSelectedDepartment}/-/-`;

    try {
      const response = await axios.get(url);

      console.log("Response OB Data:", response.data);
      setOBList(response.data);
      const mappedData = response.data.map((item) => ({
        account: item.account || "",
        jvdate: item.jvdate ? item.jvdate.split("T")[0] : "", // format date
        dept: item.deptno?.trim() || "",
        INV: item.ref || "", // your INV column seems to hold "ref"
        DESCR: item.entry_ref || "",
        ty: item.type || item.accountype || "", // type (D/C)
        amount: item.amount || 0,
        curno: item.curno || "",
        rate: item.rate || 1,
        curamount: item.curamount || 0,
        JOBCODE: item.job_code || "",
        costCode: item.COSTCODE || item.costc || "",
        selected: false, // default unchecked
      }));

      setEntries(mappedData);
    } catch (err) {
      console.error("Error OB fetching data:", err);
      setCurrencies([]);
    }
  };

  const fetchCurrencyList = async () => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    
    const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    // const url = `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`;
    try {
      //   const response = await requestCurrencyList({
      //     url: url,
      //     method: "GET",
      //     timeout: 10000,
      //   });

      const response = await axios.get(url);

      console.log("Response", response.data);
      setCurrencies(response.data || []);

      // Default currency from the fetched data
      if (response && response.length > 0) {
        // const defaultCurrency = response[0];
        const defaultCurrency = response.find((item) => item.rate === 1);
        // console.log("🚀 ~ fetchCurrencyList ~ defaultCurrency:", defaultCurrency)

        setSelectedCurrency(defaultCurrency);
      }
    } catch (err) {
      console.error("Error loading data:", err);
      setCurrencies([]);
    }
  };

  const fetchDeptCodeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`;

    try {
      const response = await axios.get(apiURL);
      console.log("🚀 ~ fetchDeptCodeList ~ response:", response.data);
      const data = response.data;
      setDeptCodeList(data || []);
    } catch (err) {
      console.error("Error while fetching accountlist", err);
    }
  };

  const handleSave = async () => {
    console.log("Saved:", entries);
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment_from_local_storage = localStorage.getItem(
      "currentSelectedDepartment"
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let currentUser_from_local_storage = localStorage.getItem("currentUser")
      ? localStorage.getItem("currentUser")
      : "-";

    const user_from_local_storage = currentUser_from_local_storage?.user;

    const saveOBPayload = () => {
      const payload = entries.map((row) => ({
        // cmpcode: company_code_from_local_storage,
        cmpcode: COMPANY_CODE,
        // operation: "ENTRY",
        operation: obList.length > 0 ? "EDIT" : "ENTRY",
        JVTYPE: "OP",
        TYPE_NO: "-99999",
        JVDATE: row.jvdate || "",
        CUST_ACC: data.accountNo || "",
        ACCDESC: data.customerName || "",
        AMOUNT: row.amount || "",
        DESCRIPT: row.DESCR || "",
        // DEPTNO: currentSelectedDepartment_from_local_storage,
        // DEPTNO: "MAIN",
        DEPTNO: row.dept || "",
        COMMENTS: "",
        // USERID: user_from_local_storage,
        USERID: "ADMIN",
        job_code: row.JOBCODE || "",
        sman_code: "",
        costc: "",
        chqno: "",
        chqdate: null,
        rate: row.rate || "1",
        pdcstatus: "",
        pdc_acc: "0",
        reason: "",
        account: data.accountNo || "",
        jvnum: "-99999",
        ref: row?.INV || "",
        entry_ref: row.DESCR || "",
        type: row.ty || "",
        curno: row.curno || "",
        curamount: row.FCBalAmt || "0",
        // user_id: user_from_local_storage,
        user_id: "ADMIN",
        accountype: row.ty || "",
        depn_p: "0",
        status1: "",
        status: "",
        appl_amt1: "0",
        appl_amt: "0",
        bank: "",
        due_date: null,
        doc_date: null,
        month: "1",
        lpono: "",
        chqprn: "",
        inv_amt: "0",
        inv_fcamt: "0",
        inv_fc: "",
        ccno: "",
        ttref: "",
        appl_cramt: "0",
        appl_crop: "0",
        appl_dramt: "0",
        pgroup: "",
        upd: "",
        v_amt: "0",
        COSTCODE: row.costCode || "",
      }));

      return payload;
    };

    const finalSaveOBPayload = saveOBPayload();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccOpenReg`;
    try {
      const response = await axios.post(apiUrl, finalSaveOBPayload, config);

      console.log("Voucher data Modified:", response.data);
      const data = response?.data;
    } catch (error) {
      console.log("error while saving reciept", error);
    }
  };

  const handleDeleteSelected = () => {
    setEntries((prev) => prev.filter((row) => !row.selected));
  };

  const totalAmount = useMemo(() => {
    return entries
      .reduce((sum, row) => {
        const amt = parseFloat(row.amount) || 0;
        return sum + amt;
      }, 0)
      .toFixed(2);
  }, [entries]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-[80vw] h-[70vh] p-4 relative">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-2 mb-3">
          <h2 className="text-lg font-semibold text-gray-700">
            Manage Opening PDC
          </h2>
          <button
            onClick={() => setOpenPDC(false)}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        {/* Account Info Section */}
        <div className="grid grid-cols-4 gap-4 mb-4">
          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 tracking-wide">
              Account
            </label>
            <input
              type="text"
              value={data.accountNo}
              readOnly
              className="w-full px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 text-sm  border border-gray-200 focus:ring-1 focus:ring-blue-400 focus:border-blue-400 transition duration-150 ease-in-out "
            />
          </div>

          <div className="flex flex-col">
            <label className="text-xs font-medium text-gray-600 mb-1 tracking-wide">
              Name
            </label>
            <input
              type="text"
              value={data.customerName}
              readOnly
              className="w-full px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 text-sm  border border-gray-200 focus:ring-1 focus:ring-blue-400 focus:border-blue-400 transition duration-150 ease-in-out "
            />
          </div>
        </div>

        <div className="mt-4 border rounded bg-white overflow-x-auto overflow-y-auto h-[48vh] mx-auto">
          <table className="min-w-full border-collapse text-sm max-h-600">
            <thead className="bg-gray-100 sticky top-0 z-20">
              <tr className="min-h-12">
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[40px]">
                  <input
                    type="checkbox"
                    className={`w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
                    focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                    checked={
                      entries.length > 0 && entries.every((e) => e?.selected)
                    }
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setEntries((prev) =>
                        prev.map((entry) => ({
                          ...entry,
                          selected: checked,
                        }))
                      );
                    }}
                  />
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                  SL No.
                </th>

                {/* <th className="border px-2 py-1 font-normal text-sm text-center min-w-[150px]">
                  Account
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[300px]">
                  Account Name
                </th> */}
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Date
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Department
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Reference
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[180px]">
                  Description
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[60px]">
                  TY
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Amount
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[240px]">
                  Cur
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[140px]">
                  Rate
                </th>
                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  FC Amount
                </th>

                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Job Code
                </th>

                <th className="border px-2 py-1 font-normal text-sm text-center min-w-[120px]">
                  Cost Code
                </th>
              </tr>
            </thead>
            <tbody>
              {entries?.map((row, index) => (
                <tr
                  key={index}
                  className="max-h-12"
                  ref={accountRowContainerRef}
                  onClick={() => setSetupBillAccount(row.account)}
                >
                  <td className="border px-2 py-1 text-center">
                    <input
                      type="checkbox"
                      checked={row?.selected || false}
                      className={` w-6 h-6 rounded-md border-gray-400 shadow-sm transition-all duration-300 ease-in-out
                    focus:ring-blue-500 focus:border-blue-500 opacity-100 cursor-pointer transition-opacity duration-300`}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setEntries((prev) => {
                          const updated = [...prev];
                          updated[index].selected = checked;
                          return updated;
                        });
                      }}
                    />
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-center">
                    {index + 1}
                  </td>

                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      type="date"
                      value={
                        row?.jvdate || new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) =>
                        handleChange(index, "jvdate", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          deptRefs.current[index]?.focus();
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded focus:ring-1 focus:ring-blue-400"
                    />
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    {/* <input
                    
                    ref={(el) => (deptRefs.current[index] = el)}
                      type="date"
                      value={
                        row?.jvdate || new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) =>
                        handleChange(index, "jvdate", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          invRefs.current[index]?.focus();
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded focus:ring-1 focus:ring-blue-400"
                    /> */}

                    {/* <select
                      // value={data.dept || ""}
                      ref={(el) => (deptRefs.current[index] = el)}
                      //   onChange={(e) => setDeptCode(e.target.value)}
                      onChange={(e) =>
                        handleChange(index, "dept", e.target.value)
                      }
                      placeholder="placeholder-gray-400 Enter Code Here..."
                      className=" px-1 py-2 m-0 text-xs  rounded border-none "
                    >
                      <option
                        className="italic text-gray-300"
                        value={data.dept}
                      >
                        {data.deptDesc}
                      </option>
                      <option className="italic text-gray-300" value={"all"}>
                        ALL
                      </option>
                      {deptCodeList.map((dept, index) => (
                        <option key={index} value={dept.deptno}>
                          {dept.deptnodesc}
                        </option>
                      ))}
                    </select> */}

                    <select
                      ref={(el) => (deptRefs.current[index] = el)}
                      value={row?.dept || ""} // Make sure we bind the selected value to code
                      onChange={(e) =>
                        handleChange(index, "dept", e.target.value)
                      }
                      className="px-1 py-2 m-0 text-xs rounded border-none bg-transparent"
                    >
                      <option className="italic text-gray-300" value="">
                        Select Dept
                      </option>
                      <option className="italic text-gray-300" value="all">
                        ALL
                      </option>
                      {deptCodeList.map((dept, i) => (
                        <option key={i} value={dept.deptno}>
                          {dept.deptnodesc}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      onFocus={(e) => e.target.select()}
                      ref={(el) => (invRefs.current[index] = el)}
                      value={row?.INV || ""} // Check both fields
                      onChange={(e) =>
                        handleChange(index, "INV", e.target.value)
                      } // Always update INV
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          descriptionRefs.current[index]?.focus();
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td>

                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (descriptionRefs.current[index] = el)}
                      value={row?.DESCR || ""}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChange(index, "DESCR", e.target.value)
                      }
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          tyRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                    />
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <button
                      ref={(el) => (tyRefs.current[index] = el)}
                      onClick={() => handleTyData(index)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          // Move focus to next row's first cell (Description input for example)
                          amountRefs.current[index]?.focus();
                        } else if (e.key === " ") {
                          e.preventDefault(); // prevent page scroll when pressing space
                          handleTyData(index); // toggle value on spacebar
                        }
                      }}
                      className={`w-full text-center px-2 py-1 text-sm rounded ${
                        // (ty[index] || row.ty) === "D"
                        row?.ty === "D" ? "bg-green-400" : "bg-red-400"
                      }`}
                    >
                      {/* {ty[index] || row.ty} */}
                      {row?.type || row?.ty}
                    </button>
                  </td>
                  {/* <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (amountRefs.current[index] = el)}
                      value={row?.amount || ""}
                      onChange={(e) =>
                        handleChange(index, "amount", e.target.value)
                      }
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          curRefs.current[index]?.focus();
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td>

                  <td className="border  text-sm font-normal text-right">
                    <select
                      ref={(el) => (curRefs.current[index] = el)}
                      value={row?.curno || ""} // use row-specific value
                      onChange={(e) => {
                        handleCurrencyChange(index, e.target.value);
                        // handler(index, "AMOUNT", e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          rateRefs.current[index]?.focus();
                        }
                      }}
                      className="w-full px-3 py-2 text-sm bg-transparent border-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {currencies?.map((currency) => (
                        <option key={currency.curno} value={currency.curno}>
                          {currency.curno} - {currency.cur.trim()}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (rateRefs.current[index] = el)}
                      // value={selectedCurrency?.rate?.toFixed(6)}
                      value={row?.rate || "1"}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={
                        (e) =>
                          // handleChange(index, "rate", e.target.value)
                          handleChangeRate(index, e.target.value)
                        // setSelectedCurrencyRate(e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          fcBalRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (fcBalRefs.current[index] = el)}
                      value={row?.curamount || row?.FCBalAmt}
                      // value={(row.AMOUNT * selectedCurrencyRate).toFixed(2)}
                      // value={row.AMOUNT}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChangeFCBalAmt(index, e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          chqNoRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td> */}

                  {/* AMOUNT */}
                  <td className="border px-1 py-0.5">
                    <input
                      ref={(el) => (amountRefs.current[index] = el)}
                      value={row.amount}
                      onChange={(e) => handleAmountChange(index, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) => e.key === "Enter" && curRefs.current[index]?.focus()}
                      className="w-full text-right px-1 py-0.5 text-sm border-none"
                    />
                  </td>

                  {/* CUR */}
                  <td className="border px-1 py-0.5">
                    <select
                      ref={(el) => (curRefs.current[index] = el)}
                      value={row.curno}
                      onChange={(e) => handleCurrencyChange(index, e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && rateRefs.current[index]?.focus()}
                      className="w-full px-1 py-0.5 text-sm bg-transparent border-none"
                    >
                      {currencies.map((c) => (
                        <option key={c.curno} value={c.curno}>
                          {c.curno} - {c.cur.trim()}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* RATE (manual) */}
                  <td className="border px-1 py-0.5">
                    <input
                      ref={(el) => (rateRefs.current[index] = el)}
                      value={row.rate}
                      onChange={(e) => handleRateChange(index, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) => e.key === "Enter" && fcBalRefs.current[index]?.focus()}
                      className="w-full text-right px-1 py-0.5 text-sm border-none"
                    />
                  </td>

                  {/* FC AMOUNT */}
                  <td className="border px-1 py-0.5">
                    <input
                      ref={(el) => (fcBalRefs.current[index] = el)}
                      value={row.FCBalAmt}
                      onChange={(e) => handleFCChange(index, e.target.value)}
                      onFocus={(e) => e.target.select()}
                      onKeyDown={(e) => e.key === "Enter" && jobCodeRefs.current[index]?.focus()}
                      className="w-full text-right px-1 py-0.5 text-sm border-none"
                    />
                  </td>

                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (jobCodeRefs.current[index] = el)}
                      value={row?.JOBCODE || ""}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChange(index, "JOBCODE", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          costCodeRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td>
                  <td className="border px-2 py-1 text-sm font-normal text-right">
                    <input
                      ref={(el) => (costCodeRefs.current[index] = el)}
                      value={row?.costCode || ""}
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) =>
                        handleChange(index, "costCode", e.target.value)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // prevent form submission or newline
                          cCenterRefs.current[index]?.focus(); // move focus to INV input
                        }
                      }}
                      className="w-full text-right px-2 py-1 text-sm border-none rounded"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center gap-3 mt-4">
          <div className="flex justify-center items-center gap-3 w-[420px]">
            <button
              onClick={handleAddRow}
              className="flex items-center justify-center gap-2 w-1/2 bg-emerald-500 text-white font-medium px-4 py-2 rounded-lg hover:bg-emerald-600 active:scale-95 transition"
            >
              <Plus className="w-4 h-4" />
              <span className="text-sm">Add Row</span>
            </button>
            <button
              onClick={handleDeleteSelected}
              disabled={!entries.some((r) => r.selected)}
              // className="flex items-center gap-1 bg-red-500 text-white px-3 py-1.5 rounded hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed"
              className="flex items-center justify-center gap-2 w-1/2 bg-red-500 text-white font-medium px-4 py-2 rounded-lg hover:bg-red-600 disabled:opacity-50 disabled:cursor-not-allowed active:scale-95 transition"
            >
              <Trash2 className="w-4 h-4" />
              Delete
            </button>

            <button
              onClick={handleSave}
              className="flex items-center justify-center gap-2 w-1/2 bg-gray-800 text-white font-medium px-4 py-2 rounded-lg hover:bg-black active:scale-95 transition"
            >
              <Save className="w-4 h-4" />
              <span className="text-sm">
                {obList.length > 0 ? "Modify" : "Save"}
              </span>
            </button>
          </div>
          <div className="font-semibold text-right">
            Total : <span className="text-blue-600">{totalAmount}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDCOpenPopup;
